import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';

const INIT_STATE = {
  selectedRows: [],
  selectedRowIds: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'SELECT_ROW': {
      const currentRows = state.selectedRows[action.currentType] || [];
      const currentRowIds = state.selectedRowIds[action.currentType] || [];

      return {
        ...state,
        selectedRows: {
          ...state.selectedRows,
          [action.currentType]: uniqBy([...currentRows, action.payload], 'id'),
        },
        selectedRowIds: {
          ...state.selectedRowIds,
          [action.currentType]: uniq([...currentRowIds, action.payload.id]),
        },
      };
    }
    case 'UNSELECT_ROW': {
      const currentRows = state.selectedRows[action.currentType] || [];
      const currentRowIds = state.selectedRowIds[action.currentType] || [];
      const newSelectedRows = [...currentRows];
      const newSelectedRowIds = [...currentRowIds];
      let selectedRowsIndex = newSelectedRows.findIndex((s) => s.id === action.payload.id);
      let selectedRowIdsIndex = newSelectedRowIds.findIndex((s) => s === action.payload.id);
      newSelectedRows.splice(selectedRowsIndex, 1);
      newSelectedRowIds.splice(selectedRowIdsIndex, 1);
      return {
        ...state,
        selectedRows: {
          ...state.selectedRows,
          [action.currentType]: uniqBy([...newSelectedRows], 'id'),
        },
        selectedRowIds: {
          ...state.selectedRowIds,
          [action.currentType]: uniq([...newSelectedRowIds]),
        },
      };
    }
    case 'RESET_SELECTED_ROWS': {
      return {
        ...state,
        selectedRows: {},
        selectedRowIds: {},
      };
    }
    default:
      return state;
  }
};
